import { Directive, HostListener, input } from '@angular/core';
import { AudioEffectPlayer, TAudioEffect } from '../utils/audio.utils';

@Directive({
  selector: '[ridSfx]',
})
export class RidSfxDirective {
  effect = input.required<TAudioEffect>({ alias: 'ridSfx' });
  animationNames = input<string[]>(['pop-in'], { alias: 'ridSfxAnimations' });

  @HostListener('animationstart', ['$event'])
  onAnimationStart(event: AnimationEvent) {
    if (this.animationNames().includes(event.animationName)) {
      AudioEffectPlayer.play(this.effect());
    }
  }
}
